const THEME_COOKIE_NAME = "theme"
const DARK_THEME = "dark"
const LIGHT_THEME = "light"

export function getThemeCookie() {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${THEME_COOKIE_NAME}=`)

  if (parts.length === 2) {
    const theme = parts.pop().split(";").shift()
    return theme === DARK_THEME || theme === LIGHT_THEME ? theme : null
  }

  return null
}

export function preferredTheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? DARK_THEME : LIGHT_THEME
}

export function currentTheme() {
  return getThemeCookie() || preferredTheme()
}

export function applyTheme(theme = currentTheme(), body = document.body) {
  const isDark = theme === DARK_THEME

  document.documentElement.classList.toggle(DARK_THEME, isDark)
  document.documentElement.dataset.theme = theme

  if (body) {
    body.classList.toggle(DARK_THEME, isDark)
  }
}

export function persistTheme(theme, days = 365) {
  const expires = new Date()
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))
  document.cookie = `${THEME_COOKIE_NAME}=${theme};expires=${expires.toUTCString()};path=/;SameSite=Lax`
}

applyTheme()

document.addEventListener("turbo:before-render", (event) => {
  applyTheme(currentTheme(), event.detail.newBody)
})

document.addEventListener("turbo:render", () => {
  applyTheme()
})

document.addEventListener("turbo:load", () => {
  applyTheme()
})

document.addEventListener("turbo:before-cache", () => {
  applyTheme()
})
